<template>
  <span class="scaling-svg-container">
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="scaling-svg">
      <g
        id="Group_240"
        data-name="Group 240"
        transform="matrix(1.326086, 0, 0, 1.326086, -2491.792799, -108.71931)"
        style=""
      >
        <g id="Icon_light" transform="translate(1876 79)">
          <g id="Icon_light-2" data-name="Icon_light" transform="translate(4 3)">
            <path
              id="Shape"
              d="M5,10a5,5,0,1,1,5-5A5.006,5.006,0,0,1,5,10ZM5,2A3,3,0,1,0,8,5,3,3,0,0,0,5,2Z"
              transform="translate(3 3)"
            ></path>
            <path
              id="Shape-2"
              data-name="Shape"
              d="M4,6H2A2,2,0,0,1,0,4V1A1,1,0,0,1,1,0H5A1,1,0,0,1,6,1V4A2,2,0,0,1,4,6ZM2,2V4H4V2Z"
              transform="translate(5 11)"
            ></path>
            <path id="Path" d="M0,1A1,1,0,0,1,2,1V2A1,1,0,0,1,0,2Z" transform="translate(7 15)"></path>
            <path id="Path-2" data-name="Path" d="M0,1A1,1,0,1,1,1,2,1,1,0,0,1,0,1Z" transform="translate(7)"></path>
            <path id="Path-3" data-name="Path" d="M1,0A1,1,0,1,1,0,1,1,1,0,0,1,1,0Z" transform="translate(14 7)"></path>
            <path id="Path-4" data-name="Path" d="M1,0A1,1,0,1,1,0,1,1,1,0,0,1,1,0Z" transform="translate(12 2)"></path>
            <path id="Path-5" data-name="Path" d="M1,0A1,1,0,1,1,0,1,1,1,0,0,1,1,0Z" transform="translate(0 7)"></path>
            <path id="Path-6" data-name="Path" d="M1,0A1,1,0,1,1,0,1,1,1,0,0,1,1,0Z" transform="translate(2 2)"></path>
          </g>
        </g>
      </g>
    </svg>
  </span>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";

@Component
export default class BulbIcon extends Vue {}
</script>

<style scoped>

</style>